"use client";

import MediaImage from "@/components/ui/MediaImage";

import { SimpleCaseData } from "@/cms/models";
import CaseSlider from "./CaseSlider";
import { SwiperSlide } from "swiper/react";
import Link from "next/link";
import RippleCtaButton from "./ui/RippleCtaButton";

const FocusEstateComponentClassicClient: React.FC<{
  config: {
    overskrift: string;
    placering: string;
    cases: (SimpleCaseData & { caseUrl: string })[];
    cmsData: any;
  };
}> = ({ config }) => {
  const { overskrift, placering, cases: casesData, cmsData } = config;

  if (!casesData || casesData.length === 0) {
    return null;
  }
  if (!cmsData?.applicationId) {
    return null;
  }

  const filteredCases = casesData.filter((x) => x !== null);

  function getPlacement() {
    switch (placering) {
      case "Center":
        return "justify-center";
      case "Højre lodret":
        return "justify-end";
      case "Højre":
        return "justify-end";
      case "Venstre":
        return "justify-start";
    }
  }

  function getTextPlacement() {
    switch (placering) {
      case "Center":
        return "justify-center";
      case "Højre":
        return "justify-start";
      case "Venstre":
        return "justify-start";
      default:
        return "justify-center";
    }
  }

  return (
    <div className="h-[400px] lg:h-[600px] w-full relative">
      <CaseSlider>
        {filteredCases.map((x, index) => (
          <SwiperSlide className="relative" key={`${x.id}-${index}`}>
            {x.imageUrl && (
              <MediaImage
                data-swiper-parallax="-100"
                src={x.imageUrl}
                alt={x.imageUrl}
                className="object-cover w-full h-full"
              />
            )}
            <div
              data-swiper-parallax="-800"
              className={`hidden lg:flex absolute inset-0 max-w-screen-xl px-8 lg:px-0  mx-auto items-center ${getPlacement()}`}
            >
              <div className="relative w-full lg:w-1/2 p-6">
                <div className="absolute inset-0 z-20 bg-white opacity-80"></div>
                <div className="relative z-20 flex flex-col text-black justify-center items-center">
                  <div className="flex flex-col gap-4 flex-1 w-full">
                    <div className="flex flex-col gap-4 flex-1 w-full">
                      <div className={`flex flex-col gap-2`}>
                        <div
                          className={`homepage-text-xl flex ${getTextPlacement()}`}
                        >
                          {overskrift}
                        </div>
                        <div
                          className={`homepage-text-sm flex ${getTextPlacement()}`}
                        >
                          {x.displayName}
                        </div>
                      </div>
                    </div>
                    <div className="hidden lg:flex justify-center">
                      <Link aria-label="Se mere" href={x.caseUrl}>
                        <RippleCtaButton>Se mere</RippleCtaButton>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Link
              data-swiper-parallax="-100"
              href={x.caseUrl}
              className="lg:hidden p-4 absolute bottom-0 left-0 right-0 bg-white opacity-80 z-10"
            >
              <div className={`homepage-text-xl flex ${getTextPlacement()}`}>
                {overskrift}
              </div>
              <div className={`homepage-text-sm flex ${getTextPlacement()}`}>
                {x.displayName}
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </CaseSlider>
    </div>
  );
};

export default FocusEstateComponentClassicClient;
